var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWalletIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#ECF9F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 14.625H24.75V12.9375C24.75 12.6259 24.498 12.375 24.1875 12.375H10.6875C9.75712 12.375 9 13.1321 9 14.0625V24.1875C9 25.1179 9.75712 25.875 10.6875 25.875H25.3125C25.623 25.875 25.875 25.623 25.875 25.3125V15.1875C25.875 14.8759 25.623 14.625 25.3125 14.625Z",
    fill: "#1EB89C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 13.5H23.625V14.625H10.6875C10.377 14.625 10.125 14.373 10.125 14.0625C10.125 13.752 10.377 13.5 10.6875 13.5Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4375 21.375H23.0625C22.131 21.375 21.375 20.619 21.375 19.6875C21.375 18.7549 22.131 18 23.0625 18H26.4375C26.748 18 27 18.252 27 18.5625V20.8125C27 21.123 26.748 21.375 26.4375 21.375Z",
    fill: "#22D1B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4101 14.6252L21.3153 10.4357C21.1758 10.1578 20.8383 10.0464 20.5604 10.1837L11.6797 14.6252H23.4101Z",
    fill: "#F4AE27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 14.6248H21.1601L19.0654 10.4353C18.9259 10.1574 18.5884 10.046 18.3105 10.1844L10.125 14.2771V14.6248Z",
    fill: "#FFBD3D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWalletIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wallet-icon.54922ba2.svg";
export { ForwardRef as ReactComponent };